export const LOCAL_TOKEN = "authToken";
